"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQueryOperationDistinctIdentity = void 0;
const bus_query_operation_1 = require("@comunica/bus-query-operation");
const core_1 = require("@comunica/core");
const utils_query_operation_1 = require("@comunica/utils-query-operation");
const RdfString = require("rdf-string");
/**
 * A comunica Distinct Identity Query Operation Actor.
 */
class ActorQueryOperationDistinctIdentity extends bus_query_operation_1.ActorQueryOperationTypedMediated {
    constructor(args) {
        super(args, 'distinct');
    }
    async testOperation(_operation, _context) {
        return (0, core_1.passTestVoid)();
    }
    async runOperation(operation, context) {
        const output = await this.mediatorQueryOperation.mediate({ operation: operation.input, context });
        if (output.type === 'quads') {
            const outputQuads = (0, utils_query_operation_1.getSafeQuads)(output);
            const quadStream = outputQuads.quadStream
                .filter(await this.newIdentityFilterQuads());
            return {
                type: 'quads',
                quadStream,
                metadata: outputQuads.metadata,
            };
        }
        const outputBindings = (0, utils_query_operation_1.getSafeBindings)(output);
        const variables = (await outputBindings.metadata()).variables.map(v => v.variable);
        const bindingsStream = outputBindings.bindingsStream
            .filter(await this.newIdentityFilter(variables));
        return {
            type: 'bindings',
            bindingsStream,
            metadata: outputBindings.metadata,
        };
    }
    /**
     * Create a new distinct filter function.
     * This will maintain an internal Identity datastructure so that every bindings object only returns true once.
     * @param variables The variables to take into account while hashing.
     * @return {(bindings: Bindings) => boolean} A distinct filter for bindings.
     */
    async newIdentityFilter(variables) {
        const identities = {};
        return (bindings) => {
            const identity = variables.map(v => RdfString.termToString(bindings.get(v))).join('-');
            return !(identity in identities) && (identities[identity] = true);
        };
    }
    /**
     * Create a new distinct filter function to Identity quads.
     * This will maintain an internal Identity datastructure so that every quad object only returns true once.
     * @return {(quad: RDF.Quad) => boolean} A distinct filter for quads.
     */
    async newIdentityFilterQuads() {
        const identities = {};
        return (quad) => {
            const identity = Object.values(RdfString.quadToStringQuad(quad)).join(' ');
            return !(identity in identities) && (identities[identity] = true);
        };
    }
}
exports.ActorQueryOperationDistinctIdentity = ActorQueryOperationDistinctIdentity;
//# sourceMappingURL=ActorQueryOperationDistinctIdentity.js.map